module.exports = __webpack_public_path__ + "static/media/eng_d_2027.fd621a6b.vtt";